import { Component, Vue } from 'vue-property-decorator';

@Component
export default class AuthMixin extends Vue {
  get authState() {
    return this.$oauth.authState;
  }

  get authUser() {
    if (this.$appName === undefined) {
      return null;
    }
    return this.authState[this.$appName].tokenPayload;
  }

  get authToken() {
    if (this.$appName === undefined) {
      return null;
    }
    return this.authState[this.$appName].accessToken;
  }

  get authorized(): boolean {
    return !!this.authToken && !!this.authUser;
  }

  checkTokenValid() {
    if (this.$appName === undefined) {
      return true;
    }
    return this.$oauth.checkTokenValid(this.$appName);
  }

  checkTokenExpired() {
    return this.authorized && !this.checkTokenValid();
  }

  async revokeToken(): Promise<boolean> {
    if (this.$appName === undefined) {
      return true;
    }
    return this.$oauth.revokeToken(this.$appName);
  }

  async refreshToken(): Promise<boolean> {
    if (this.$appName === undefined) {
      return true;
    }
    return this.$oauth.refreshToken(this.$appName).then(() => true);
  }

  resetToken() {
    if (this.$appName === undefined) {
      return true;
    }
    return this.$oauth.resetToken(this.$appName);
  }
}
